import * as React from "react";
const ReactModal = require('react-modal');
import moment from "moment";
export default class EventModal extends React.Component {
    constructor(props) {
        super(props);
        this.customStyle = {
            overlay: {
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.4)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 10
            },
            content: {
                position: 'relative',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: '#fff',
                overflow: 'auto',
                WebkitOverflowScrolling: 'touch',
                outline: 'none',
                padding: '0',
                width: '46rem',
                maxHeight: '90%',
                height: 'auto',
                border: 'none'
            }
        };
    }
    render() {
        let premiumModal = this.props.PremiumEvent ? React.createElement("div", { className: "event-modal-premium" }, "PREMIUM") : null;
        let imgModal = React.createElement("div", { className: "event-modal-img" },
            this.props.imgPath ? React.createElement("img", { alt: "pic", src: this.props.imgPath }) : null,
            React.createElement("div", { className: "event-modal-header" },
                premiumModal,
                React.createElement("i", { className: "fa fa-times-circle", onClick: this.props.toggleModal })));
        let timeformat = moment(new Date(this.props.StartDate)).format('L') === moment(new Date(this.props.EndDate)).format('L') ?
            "h:mm A" : "MMM DD YYYY, h:mm A";
        let time = `${moment(new Date(this.props.StartDate)).format('h:mm A')} - ${moment(new Date(this.props.EndDate)).format(timeformat)}`;
        let websiteBtn = this.props.Website ? React.createElement("a", { href: this.props.Website, className: "button-containers" },
            React.createElement("button", { className: "btn-primary btn-primary__filled" }, "Event Website")) : null;
        return (React.createElement(ReactModal, { isOpen: this.props.toggle, style: this.customStyle, contentLabel: "event label", onRequestClose: this.props.toggleModal },
            React.createElement("div", { className: this.props.PremiumEvent ? "event-modal-item featured" : "event-modal-item" },
                imgModal,
                React.createElement("div", { className: "event-content" },
                    React.createElement("div", { className: "event-date" },
                        React.createElement("span", { className: "date" }, moment(new Date(this.props.StartDate)).format('DD')),
                        React.createElement("span", { className: "month" }, moment(new Date(this.props.StartDate)).format('MMM')),
                        React.createElement("span", { className: "time" }, time)),
                    React.createElement("div", { className: "event-main" },
                        React.createElement("p", { className: "event-title" }, this.props.Name),
                        React.createElement("p", { className: "event-location" }, this.props.LocationName)),
                    React.createElement("div", { className: "event-desc" },
                        React.createElement("div", { className: "event-desc-header" }, "Description"),
                        React.createElement("div", { className: "event-details" }, this.props.Description),
                        websiteBtn,
                        React.createElement("a", { className: "button-containers", href: `https://www.google.com/maps/dir//'${this.props.Latitude},${this.props.Longitude}'` },
                            React.createElement("button", { className: "btn-primary btn-primary__filled" }, "Get Directions")))))));
    }
}
;
//# sourceMappingURL=event-modal.js.map